var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',_vm._l((_vm.textSections),function(textSection,sectionIndex){return _c('text-section',{key:'section-' + (sectionIndex + 1),attrs:{"content":textSection.content,"is-numbered":textSection.isNumbered}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }